import React, { useEffect, useRef, useState } from 'react';
import { useStyles } from './ecosystem.module';

const useCountUp = (target, duration = 1500, start = false) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!start) return;
    const numeric = parseFloat(target.replace(/[^0-9.]/g, ''));
    const prefix = target.match(/^\D*/)?.[0] || '';
    const suffix = target.match(/[A-Za-z%]+$/)?.[0] || '';
    let startTime = null;

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount({ value: Math.floor(eased * numeric), prefix, suffix });
      if (progress < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  }, [start, target, duration]);

  if (typeof count === 'object') {
    return `${count.prefix}${count.value}${count.suffix}`;
  }
  return '0';
};

const AnimatedMetric = ({ value, label, classes }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);
  const animated = useCountUp(value, 1500, visible);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={classes.metricBox}>
      <span className={classes.metricValue}>{animated}</span>
      <span className={classes.metricLabel}>{label}</span>
    </div>
  );
};

const EcosystemTraction = () => {
  const classes = useStyles();

  const metrics = [
    { id: 'm1', value: '2.5M', label: 'TONCO2E REMOVED' },
    { id: 'm2', value: '$64M', label: 'PORTFOLIO VALUE' },
    { id: 'm3', value: '5',    label: 'ACTIVE PROJECTS' },
  ];

  const partners = ['Stellar', 'Techstars', 'Sylvera', 'LiDAR', 'Biocarbon', 'ERM'];

  return (
    <section className={classes.sectionContainer}>
      <div>
        <h2 className={classes.sectionHeader}>ECOSYSTEM TRACTION</h2>
      </div>

      <div className={classes.metricsContainer}>
        {metrics.map((metric) => (
          <AnimatedMetric
            key={metric.id}
            value={metric.value}
            label={metric.label}
            classes={classes}
          />
        ))}
      </div>

      <div className={classes.partnersContainer}>
        <h3 className={classes.sectionHeader}>TRUSTED PARTNERS</h3>
        <div className={classes.partnersGrid}>
          {partners.map((partner, index) => (
            <span
              key={index}
              className={classes.partnerItem}
              style={{ animationDelay: `${index * 0.08}s` }}
            >
              {partner}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EcosystemTraction;